import Vue from "vue";
import VuetifyConfirm from "vuetify-confirm";
import Vuetify from "vuetify/lib";
import FBDIcon from "src/icons/FBD.vue";
import ILIcon from "src/icons/IL.vue";
import LDIcon from "src/icons/LD.vue";
import PIcon from "src/icons/P.vue";
import RIcon from "src/icons/R.vue";
import SFCIcon from "src/icons/SFC.vue";
import STIcon from "src/icons/ST.vue";
import FBIcon from "src/icons/FB.vue";
import TIcon from "src/icons/T.vue";
import FIcon from "src/icons/F.vue";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  icons: {
    values: {
      fbd: {
        component: FBDIcon,
      },
      il: {
        component: ILIcon,
      },
      ld: {
        component: LDIcon,
      },
      p: {
        component: PIcon,
      },
      r: {
        component: RIcon,
      },
      sfc: {
        component: SFCIcon,
      },
      st: {
        component: STIcon,
      },
      fb: {
        component: FBIcon,
      },
      t: {
        component: TIcon,
      },
      f: {
        component: FIcon,
      },
    },
  },
});

Vue.use(VuetifyConfirm, { vuetify });

export default vuetify;
